module.exports = __webpack_public_path__ + "img/rebuild_huang_pad_bg.7d7c8748.png";